import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/views/Home.vue'),
        },
        {
          path: 'book',
          name: 'book',
          component: () => import('@/views/Book.vue'),
        },
        {
          path: 'swap',
          name: 'swap',
          component: () => import('@/views/Swap.vue'),
        },
        {
          path: 'trade',
          name: 'trade',
          component: () => import('@/views/Trade.vue'),
        },
            {
          path: 'start',
          name: 'start',
          component: () => import('@/views/Start.vue'),
        },
        {
          path: 'miner',
          name: 'miner',
          component: () => import('@/views/Miner.vue'),
        },

        {
          path: 'profile',
          name: 'profile',
          component: () => import('@/views/Profile.vue'),
        },
      ],
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.path !== from.path) {
      return { top: 0, left: 0 }
    }
    return false
  },
})

export default router
